import React, { createContext, useContext, useState, useEffect } from "react";
import { createDashboardTheme } from "./dashboardTheme";

const DashboardThemeContext = createContext();

const defaultDashboardConfig = {
  primaryColor: "#472ed1",
  secondaryColor: "#db3a3e",
  mode: "light",
  fontFamily: "Poppins",
  fontSize: 14,
  borderRadius: 16,
  spacing: 8,
  compactMode: false,
};

export const useDashboardTheme = () => {
  const context = useContext(DashboardThemeContext);
  if (!context) {
    throw new Error(
      "useDashboardTheme must be used within DashboardThemeProvider"
    );
  }
  return context;
};

export const DashboardThemeProvider = ({ children }) => {
  const [themeConfig, setThemeConfig] = useState(() => {
    try {
      const saved = localStorage.getItem("dashboardThemeConfig");
      return saved ? JSON.parse(saved) : defaultDashboardConfig;
    } catch (error) {
      return defaultDashboardConfig;
    }
  });

  useEffect(() => {
    localStorage.setItem("dashboardThemeConfig", JSON.stringify(themeConfig));
  }, [themeConfig]);

  const updateTheme = (newConfig) => {
    setThemeConfig((prev) => ({ ...prev, ...newConfig }));
  };

  const resetTheme = () => {
    setThemeConfig(defaultDashboardConfig);
  };

  const dashboardTheme = createDashboardTheme(themeConfig);

  return (
    <DashboardThemeContext.Provider
      value={{
        themeConfig,
        updateTheme,
        resetTheme,
        dashboardTheme,
      }}
    >
      {children}
    </DashboardThemeContext.Provider>
  );
};
